module.exports = __webpack_public_path__ + "img/resource5.5329c8b8.jpg";